<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>测试题库</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <div
            class="add-btn"
            style="margin-bottom:0;"
            @click="showAddWindow()"
          >添加试题</div>
          <!-- <router-link
            tag="div"
            :to="'/www/lesson_detail?id=' + lessonInfo.id"
            class="add-btn"
          >预览</router-link> -->
          <!-- <div
            v-if="lessonInfo.status==0"
            class="add-btn"
            @click="$parent.saveOnline(lessonInfo.title, lessonInfo.id)"
          >提交审核</div> -->
        </div>
      </div>
      <div id="searchSection">
        <div class="search-line clearfix">
          <select
            class="s-select separate"
            v-model="queryInfo.questionType"
          >
            <option value="">试题类型</option>
            <option :value="1">单选题</option>
            <option :value="2">多选题</option>
            <option :value="3">判断题</option>
          </select>
          <input
            type="text"
            placeholder="题干"
            class="s-input separate"
            v-model="queryInfo.content"
            autocomplete="off"
            maxlength="50"
          >
          <input
            type="number"
            placeholder="分值"
            class="s-input separate"
            v-model="queryInfo.grade"
            autocomplete="off"
            maxlength="3"
          >
          <input
            type="button"
            value="搜索"
            @click="getQuestionInfo"
            class="s-btn"
          >
        </div>
      </div>
      <div id="list">
        <table>
          <tbody>
            <tr class="l_header">
              <th class="itemStatus">类型</th>
              <th class="itemStatus">题干</th>
              <th class="itemStatus">分值</th>
              <th class="itemStatus">创建时间</th>
              <th
                class="action"
                width="130"
              >操作</th>
            </tr>
            <tr
              class="item"
              v-for="(item,index) in tableData"
              :key="index"
            >
              <td class="itemStatus">{{formatType(item.questionType)}}</td>
              <td
                class="itemStatus"
                v-html="removeHtmlStyle(item.content)"
              ></td>
              <td class="itemStatus">{{item.grade}}</td>
              <td class="itemStatus">{{formatDate(item.created)}}</td>
              <td class="action">
                <a
                  class="edit"
                  href="javascript:;"
                  @click="querySingle(item.id)"
                >编辑</a>
                <a
                  class="delete"
                  href="javascript:;"
                  @click="delInfo(item)"
                >删除</a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-if="!tableData.length"
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <!-- 新增/编辑弹窗 -->
    <div
      class="form_overlay"
      :style="classShowAddWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">添加/修改试题</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>试题类型:</span>
              <select
                class="s-select separate"
                v-model="formInfo.questionType"
                @change="changeQuestionType"
              >
                <option :value="1">单选题</option>
                <option :value="2">多选题</option>
                <option :value="3">判断题</option>
              </select>
            </div>

            <div class="item">
              <span class="label"><i class="require">*</i>分值:</span>
              <input
                type="number"
                autocomplete="off"
                v-model="formInfo.grade"
                maxlength="3"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>题干:</span>
              <div class="k-container1 ">
                <vue-ueditor-wrap
                  :config="editorConfig"
                  v-model="formInfo.content"
                  editor-id="editor-demo-01"
                ></vue-ueditor-wrap>
              </div>
            </div>
            <div class="item add-item">
              <span class="label"><i class="require">*</i>选项:</span>
              <div v-if="formInfo.questionType==1 || formInfo.questionType==2">
                <div
                  v-for='(item,index) in optionInfo'
                  :key="index"
                >
                  <div v-if="formInfo.questionType==1">
                    <input
                      type="text"
                      v-model="item.title"
                      autocomplete="off"
                      maxlength="25"
                    >
                    <span
                      class="del"
                      @click="delOption(index)"
                    >x</span>
                    <div class="item">
                      <span class="label"><i class="require"></i>是否正确答案:</span>
                      <div class="k-container col1">
                        <label class="check-label">
                          <input
                            class="elevel"
                            type="radio"
                            :checked="item.isAnswer == 1"
                            @change="onRadioChange(); item.isAnswer = 1"
                            autocomplete="off"
                          ></label>

                      </div>
                    </div>
                  </div>
                  <div v-if="formInfo.questionType==2">
                    <input
                      type="text"
                      v-model="item.title"
                      autocomplete="off"
                      maxlength="25"
                    >
                    <span
                      class="del"
                      @click="delOption(index)"
                    >x</span>
                    <div class="item">
                      <span class="label"><i class="require"></i>是否正确答案:</span>
                      <div class="k-container col1">
                        <label class="check-label">
                          <input
                            class="elevel"
                            type="checkbox"
                            v-model="item.isAnswer"
                            autocomplete="off"
                          ></label>

                      </div>
                    </div>
                  </div>

                </div>
                <span
                  class="add-option"
                  @click="addOption"
                >添加一个选项</span>
              </div>
              <div v-if="formInfo.questionType==3">
                <div
                  class="k-container col1"
                  v-for='(item,index) in optionInfo'
                  :key="index"
                >
                  {{picked}}
                  <label class="check-label">
                    <input
                      class="elevel"
                      type="radio"
                      :checked="item.isAnswer == 1"
                      @change="onRadioChange(); item.isAnswer = 1"
                      autocomplete="off"
                    >{{item.title}}</label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideAddWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveInfo"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import Pagination from '../../../components/Pager'
export default {
  name: 'OnlineQuestion',
  components: {
    VueUeditorWrap,
    Pagination
  },
  props: ['lessonInfo'],
  data() {
    return {
      tableData: [],
      tableDataCount: 0,
      manager: {},
      classShowAddWindow: {
        visibility: 'hidden'
      },
      editorConfig: {
        // 访问 UEditor 静态资源的根路径，可参考 https://hc199421.gitee.io/vue-ueditor-wrap/#/faq
        UEDITOR_HOME_URL: '/UE/',
        // 服务端接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: '//ueditor.szcloudplus.com/cos',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        // imagePathFormat: '/files/{yyyy}{mm}{dd}-{time}{rand:6}',
        // imageUrlPrefix: 'http://localhost:8000'
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      formInfo: {
        id: null,
        lessonOnline_id: this.$route.query.id,
        questionType: 1,
        grade: '',
        content: '',
        bank: 1
      },
      queryInfo: {
        page: 1,
        size: 10,
        lessonOnline_id: this.$route.query.id,
        questionType: '',
        grade: '',
        bank: '1'
      },
      optionInfo: [],
      questionOption: [],
      picked: '',
      sensitiveWord: []
    }
  },

  methods: {
    removeHtmlStyle(html) {
      const rel = /style\s*?=\s*?([‘"])[\s\S]*?\1/g
      let newHtml = ''
      if (html) {
        newHtml = html.replace(rel, '')
      }
      return newHtml
    },
    onRadioChange() {
      for (let i = 0; i < this.optionInfo.length; i++) {
        this.optionInfo[i].isAnswer = 0
      }
    },
    formatType(code) {
      if (code === 1) {
        return '单选题'
      } else if (code === 2) {
        return '多选题'
      } else if (code === 3) {
        return '判断题'
      }
    },
    formatDate(value) {
      const dateRes = value.replace('T', ' ').substring(0, value.indexOf('.'))
      return dateRes
    },
    showAddWindow() {
      this.classShowAddWindow = {
        visibility: 'visible'
      }
    },
    hideAddWindow() {
      this.classShowAddWindow = {
        visibility: 'hidden'
      }
      this.formInfo = {
        id: null,
        lessonOnline_id: this.$route.query.id,
        questionType: 1,
        grade: '',
        content: '',
        bank: 1
      }
      this.optionInfo = []
    },
    changeQuestionType(e) {
      this.optionInfo = []
      if (e.target.value === '3') {
        this.optionInfo = [
          {
            question_id: '',
            title: '对',
            isAnswer: 0,
            value: 1
          },
          {
            question_id: '',
            title: '错',
            isAnswer: 0,
            value: 0
          }
        ]
      }
    },
    // 编辑时查询
    async querySingle(id) {
      this.showAddWindow()
      const url = '/online_question/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo = {
          id: data.id,
          lessonOnline_id: this.$route.query.id,
          questionType: Number(data.questionType),
          grade: data.grade,
          content: data.content,
          bank: 1
        }
        this.getQuestionOptionInfo(data.id)
      }).catch((error) => {
        console.log(error)
      })
    },
    async delInfo(item) {
      const url = '/online_question/' + item.id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$parent.showMsg('删除成功！')
          this.getQuestionInfo()
        }).catch((error) => {
          console.log(error)
          this.$parent.showMsg('删除失败！')
        })
      })
    },
    async saveInfo() {
      if (!this.formInfo.grade) {
        this.$layer.msg('请填写分值！')
        return
      }

      if (Number(this.formInfo.grade) < 0) {
        this.$layer.msg('分值必须大于或等于0！')
        return
      }
      if (!this.formInfo.content) {
        this.$layer.msg('请填写题干！')
        return
      }
      if (!this.optionInfo.length) {
        this.$layer.msg('请添加试题选项！')
        return
      }
      var checkTitle = this.optionInfo.some((item) => {
        return item.title === ''
      })
      if (checkTitle) {
        this.$layer.msg('请填写选项内容')
        return
      }
      var checkOption = this.optionInfo.every((item) => {
        return Number(item.isAnswer) === 0
      })
      if (checkOption) {
        this.$layer.msg('请选择答案')
        return
      }
      if (this.optionInfo.length === 1) {
        this.$layer.msg('请至少添加两个选项！')
      }
      const isRight = this.utils.getWords(this.formInfo.content, this.sensitiveWord)
      if (isRight) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      const data = {
        id: this.formInfo.id,
        lessonOnline_id: this.formInfo.lessonOnline_id,
        questionType: this.formInfo.questionType,
        grade: this.formInfo.grade,
        content: this.formInfo.content,
        bank: this.formInfo.bank,
        answer: '',
        options: []
      }
      for (let i = 0; i < this.optionInfo.length; i++) {
        data.options.push({
          title: this.optionInfo[i].title,
          isAnswer: this.optionInfo[i].isAnswer ? 1 : 0
        })
      }
      await this.$http.post('/online_question_save/', {
        json_data: JSON.stringify(data)
      }).then((data) => {
        if (data.code === '200') {
          this.$parent.showMsg('添加成功！')
          this.hideAddWindow()
          this.getQuestionInfo()
        } else {
          this.$parent.showMsg('添加失败！')
        }
      })
    },

    // 添加选项
    addOption() {
      const option = {
        question_id: '',
        title: '',
        isAnswer: 0
      }
      this.optionInfo.push(option)
    },
    // 删除选项
    delOption(index) {
      this.optionInfo.splice(index, 1)
    },
    // 获取题库信息
    async getQuestionInfo() {
      await this.$http.get('/online_question/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch(() => {
        this.$layer.msg('获取题库信息失败！')
      })
    },
    // 获取试题选项信息
    async getQuestionOptionInfo(id) {
      const params = {
        question_id: id
      }
      await this.$http.get('/online_question_option/', { params }).then((data) => {
        this.questionOption = [...data.results]
        this.optionInfo = [...data.results]
      }).catch(() => {
        this.$layer.msg('获取题库信息失败！')
      })
    },
    // 分页
    pageCallback(data) {
      this.queryInfo.page = data
      this.getQuestionInfo()
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mounted() {
    this.getQuestionInfo()
    this.getSensitiveWord()
  },
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  }
}
</script>
<style scoped src="@/assets/css/project-detail.css"></style>
<style lang="less" scoped>
.panel-content {
  padding: 20px 40px;
}
.c-content {
  margin: 0;
  transform: translate(-50%, -50%);
}
.itemStatus {
  img {
    width: 120px;
  }
}
#c-panel {
  z-index: 2;
}
.c-content {
  min-height: 650px;
}
.active {
  color: #266dc7 !important;
  text-decoration: underline;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      margin-bottom: 0;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.crumb_nav {
  color: #999;
  margin-top: 20px;
}
.add-btn {
  width: unset;
  height: unset;
  line-height: normal;
}
// 公告
.notice_info {
  min-height: 130px;
  margin-bottom: 20px;
  border: 1px solid #eee;
  &:last-child {
    margin-bottom: 0;
  }
  .notice_title {
    background: #eee;
    padding: 10px 20px;
    font-size: 16px;
    color: #333;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      &:last-child {
        font-size: 12px;
        color: #999;
        margin-top: 10px;
        span {
          margin-right: 20px;
        }
      }
    }
    .handle_btn {
      a {
        margin-right: 20px;
        color: #999;
      }
    }
  }
  .notice_content {
    padding: 10px 20px;
    color: #333;
  }
}
.k-container1 {
  float: left;
  max-width: 500px;
}
.add-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .item {
    .label {
      padding-left: 0;
    }
  }
}
.add-option {
  padding: 5px 10px;
  border: 1px solid #ccc;
  background: #eee;
  cursor: pointer;
}
.del {
  color: red;
  font-size: 18px;
  background: none;
}
.form_overlay {
  z-index: 2;
}
</style>
